import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { signOut } from 'firebase/auth';
import { auth } from '../../../firebase';

import Actions from '../../../components/layout/Actions';
import GroupList from '../../../components/group/GroupList';
import Content from '../../../components/layout/Content';
import Title from '../../../components/layout/Title';

import LogoutModal from '../../../components/layout/modals/LogoutModal';
import Card from '../../../components/ui/Card';

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { startConsumptionsListener } from '../../../store/listeners';

const Home = () => {
  const dispatch = useAppDispatch();
  const loggedIn = useAppSelector(state => state.auth.loggedIn);
  const consumptions = useAppSelector(state => state.consumptions.consumptions);
  const navigate = useNavigate();
  const [showLogoutConfirmationModal, setShowLogoutConfirmationModal] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(startConsumptionsListener());
  }, [dispatch]);

  // Calculate total consumptions
  const totalConsumptions = consumptions.reduce((total, consumption) => total + consumption.score, 0);

  const addConsumptionsHandler = async () => {
    navigate('/afterwork/add');
  };

  const logoutBeginHandler = () => {
    setShowLogoutConfirmationModal(true);
  };

  const logoutConfirmHandler = () => {
    setShowLogoutConfirmationModal(false);
    if (loggedIn) {
      signOut(auth);
    }
  };

  const logoutCancelHandler = () => {
    setShowLogoutConfirmationModal(false);
  };

  const logoutConfirmationModal = createPortal(
    <LogoutModal onCancel={logoutCancelHandler} onLogout={logoutConfirmHandler} />,
    document.getElementById('modal')!
  );

  return (
    <Content>
      {showLogoutConfirmationModal && logoutConfirmationModal}
      <Title titleText="Vossingers Afterwork" backButton={true} />
      <Card extraStyles={{ flex: 0.1 }} withMargin="bottom">
        <h2 style={{ fontSize: 'min(1.5em, 4vw)', margin: 0 }}>
          {t('afterwork.totalConsumptions')}: {totalConsumptions}&#127866;
        </h2>
      </Card>
      <Card extraStyles={{ overflow: 'auto', justifyContent: 'start' }}>
        <GroupList />
      </Card>
      {loggedIn && <Actions onLogout={logoutBeginHandler} onAddConsumptions={addConsumptionsHandler} />}
    </Content>
  );
};

export default Home;
